//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        info:{
            type:Object,
            default:function(){
                return {
                    category:{
                        id:''
                    }
                }
            }
        },
        kindType:{
            type:Array,
            default:()=>{return []}
        }
    },
    data() {
        return {
      
        }
    },
    methods: {
        change(){
            this.$emit('click',this.info.id)
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/Scicard.vue